module.exports = __webpack_public_path__ + "img/IT0000643846620.c30f36f4.png";